module.exports = __webpack_public_path__ + "img/711StoreMarker.b0087c0.svg";